import { bemClassBuilder } from '@vista-digital/bem-class-builder'
import { Icon } from '@vista-digital/occ-ui/src/lib/subcomponents/icon'

interface CarouselAutoPlayToggleButtonProps {
    onClick: VoidFunction
    isPlaying: boolean
}

const b = bemClassBuilder('v-carousel-auto-play-toggle-button')

export const CarouselAutoPlayToggleButton: React.FC<CarouselAutoPlayToggleButtonProps> = props => {
    const { onClick, isPlaying } = props

    return (
        <button className={b.block()} onClick={onClick} aria-label={isPlaying ? 'pause' : 'play'}>
            <Icon className={b.element('icon')} name={isPlaying ? 'pause' : 'play'} />
        </button>
    )
}

CarouselAutoPlayToggleButton.displayName = 'CarouselAutoPlayToggleButton'
